/* eslint-disable @typescript-eslint/no-shadow */
import { Typography } from '@mui/material';
import { get } from 'lodash';
import React from 'react';
import PriceDetailsNotification from '../../containers/PriceDetailsNotification';

import { TPriceDetailsProps } from './type';

const PriceDetails: React.FC<TPriceDetailsProps> = (
  {
    flightArr,
    passenger,
    onCloseButton,
    onNextButton,
    baggagePrice,
    baggagePriceDepart,
    baggagePriceReturn,
    isDesktop,
    isPayment,
    flightPriceDiff,
    // discountAmount,
    isDepart,
  },
) => {
  const scheduleArr = (flightArr || []).filter((flight) => flight).map((flight) => get(flight, 'route.schedules[0]'));
  if (scheduleArr.length === 0) {
    return <Typography>Không có thông tin chuyến bay</Typography>;
  }

  const { adt: adult, chd: child, inf: infant } = passenger || {};
  const {
    adtFare, chdFare, infFare, taxFee, discountAmt, taxAdt, taxChild, taxInfant,
  } = [scheduleArr[0]].reduce((resultObj, schedule, index) => {
    const {
      fareAdult, fareChild, fareInfant,
      taxAdult, taxChild, taxInfant,
      feeAdult, feeChild, feeInfant,
      serviceFeeAdult, serviceFeeChild, serviceFeeInfant,
      discountAmount,
    } = schedule;
    const taxPrice = (adult * (taxAdult + feeAdult + serviceFeeAdult))
    + (child * (taxChild + feeChild + serviceFeeChild))
    + (infant * (taxInfant + feeInfant + serviceFeeInfant));

    resultObj.discountAmt += (discountAmount || 0);
    resultObj.adtFare += adult * fareAdult;
    resultObj.chdFare += child * fareChild;
    resultObj.infFare += infant * fareInfant;
    resultObj.taxFee += taxPrice;
    resultObj.taxAdt += adult * (taxAdult + feeAdult + serviceFeeAdult);
    resultObj.taxChild += child * (taxChild + feeChild + serviceFeeChild);
    resultObj.taxInfant += infant * (taxInfant + feeInfant + serviceFeeInfant);
    if (index === 0) {
      resultObj.taxDepart = taxPrice;
    } else {
      resultObj.taxReturn = taxPrice;
    }

    return resultObj;
  }, {
    adtFare: 0,
    chdFare: 0,
    infFare: 0,
    taxAdt: 0,
    taxChild: 0,
    taxFee: 0,
    taxInfant: 0,
    discountAmt: 0,
  });

  const priceReturn = scheduleArr[1] && [scheduleArr[1]].reduce((resultObj, schedule, index) => {
    const {
      fareAdult, fareChild, fareInfant,
      taxAdult, taxChild, taxInfant,
      feeAdult, feeChild, feeInfant,
      serviceFeeAdult, serviceFeeChild, serviceFeeInfant,
      discountAmount,
    } = schedule;
    const taxPrice = (adult * (taxAdult + feeAdult + serviceFeeAdult))
    + (child * (taxChild + feeChild + serviceFeeChild))
    + (infant * (taxInfant + feeInfant + serviceFeeInfant));

    resultObj.discountAmt += (discountAmount || 0);
    resultObj.adtFare += adult * fareAdult;
    resultObj.chdFare += child * fareChild;
    resultObj.infFare += infant * fareInfant;
    resultObj.taxFee += taxPrice;
    resultObj.taxAdt += adult * (taxAdult + feeAdult + serviceFeeAdult);
    resultObj.taxChild += child * (taxChild + feeChild + serviceFeeChild);
    resultObj.taxInfant += infant * (taxInfant + feeInfant + serviceFeeInfant);
    if (index === 0) {
      resultObj.taxDepart = taxPrice;
    } else {
      resultObj.taxReturn = taxPrice;
    }

    return resultObj;
  }, {
    adtFare: 0,
    chdFare: 0,
    infFare: 0,
    taxFee: 0,
    taxAdt: 0,
    taxChild: 0,
    taxInfant: 0,
    discountAmt: 0,
  });

  return (
    <PriceDetailsNotification
      priceReturn={priceReturn}
      isRoundTrip={!!priceReturn}
      taxAdt={taxAdt}
      taxChild={taxChild}
      taxInfant={taxInfant}
      adult={adult}
      isDesktop={isDesktop}
      adtFare={adtFare}
      child={child}
      chdFare={chdFare}
      infant={infant}
      onClose={onCloseButton}
      onNext={onNextButton}
      taxFee={taxFee}
      infFare={infFare}
      baggagePrice={baggagePrice}
      baggagePriceDepart={baggagePriceDepart}
      baggagePriceReturn={baggagePriceReturn}
      isPayment={isPayment}
      flightPriceDiff={flightPriceDiff}
      discountAmount={discountAmt}
      isDepart={isDepart}
    />
  );
};

export default React.memo(PriceDetails);
